module.exports = __webpack_public_path__ + "img/摄图网_500559818_banner_现代化金融城市（非企业商用）.09971319.png";